import { useState } from 'react';

export function usePagination(pageSize = 10) {
  const [pagination, setPagination] = useState({ limit: pageSize, skip: 0 });

  const setPaginationLimit = (limit: number) => {
    setPagination((prev) => ({ ...prev, limit }));
  };

  const moveToNextPage = () => {
    const page = pagination.skip + pagination.limit;
    setPagination((prev) => ({ ...prev, skip: page }));
    return page;
  };

  const moveToPreviousPage = () => {
    const page = pagination.skip - pagination.limit;
    setPagination((prev) => ({ ...prev, skip: page }));
    return page;
  };

  const resetPagination = () => {
    setPagination({ limit: pageSize, skip: 0 });
  };

  return { pagination, setPaginationLimit, moveToNextPage, moveToPreviousPage, resetPagination };
}
